import React, { FC } from "react";
import { Icon, Button } from "@scuf/common";
import { useNavigate } from "react-router-dom";
import "./NotFound.scss";

export const NotFoundPage: FC = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container">
      <div className="not-found">
        <Icon name="badge-warning" size="xlarge" />
        <h1 id="headerPageNotFound">Page Not Found</h1>
        <Button
          className="routeToHomeButton"
          onClick={() => navigate("/")}
          type="secondary"
          content="Please return to landing page."
        />
      </div>
    </div>
  );
};

export default NotFoundPage;
